import { render, staticRenderFns } from "./QuestionController.vue?vue&type=template&id=21646817&"
import script from "./QuestionController.vue?vue&type=script&lang=js&"
export * from "./QuestionController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports